// extracted by mini-css-extract-plugin
module.exports = {"blockImageMargin":"blockVideoMargin-module--blockImageMargin--3uwNH"};